var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop1 = function SvgTop1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "m17.685-.768 3.46 10.402 26.436 45.825 10.168-5.407L34.403 2.584l-4.55-8.998L17.686-.768Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.112-2.463 10.306-5.48 30.825 57.975-10.305 5.48L5.112-2.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "M63.567-3.167 53.399-8.573 22.435 49.662l10.168 5.406L58.868 9.565l4.699-12.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m64.41-7.677 10.306 5.48-30.67 57.681-10.305-5.48 30.67-57.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D769",
    d: "M40.031 26.559 38.36 57.1l1.672 29.873c16.735 0 30.344-13.552 30.344-30.215-.016-16.648-13.625-30.2-30.344-30.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D769",
    d: "M9.688 56.758c0 16.663 13.609 30.215 30.343 30.215V26.56c-16.734 0-30.343 13.551-30.343 30.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB32",
    d: "M40.031 31.226 38.36 57.1l1.672 25.205c14.14 0 25.657-11.45 25.657-25.547-.016-14.08-11.516-25.532-25.657-25.532Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB32",
    d: "M14.375 56.758c0 14.096 11.5 25.547 25.656 25.547V31.226c-14.156 0-25.656 11.452-25.656 25.532Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.797 66.7h6.234V48.42h-5.25V44.87c2.907-.544 4.907-1.291 6.75-2.427h4.282V66.7h5.453v4.652h-17.47V66.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v87.129H0z"
  })))));
};
export default SvgTop1;